import { OrderList, MenuButton } from "@velocity-ehs/component-library";
import classes from "./ListItems.module.scss";
import StatusTag from "../../sharedComponents/StatusTag";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import { EhsListItem } from "./EhsListsManagement";
import { handleStatusChange } from "./Utils";

enum ListItemStatus {
  Active = "Active",
  Inactive = "Inactive",
}

interface Props {
  items: React.ReactNode;
  onOpenEdit: (item: EhsListItem) => void;
  onStatusChange?: (item: EhsListItem) => void;
}

const ListItems: React.FC<Props> = ({ items, onOpenEdit, onStatusChange }) => {
  const { t } = useTranslation();
  const cx = classNames.bind(classes);

  const rowActions = (item: any) => {
    return [
      {
        command: () => onOpenEdit(item),
        label: t("action_edit"),
        visible: item.enabled,
      },
      {
        command: () => handleStatusChange(item, onStatusChange, t),
        label: item.enabled
          ? t("universal_Inactivate")
          : t("universal_Activate"),
      },
    ];
  };

  function getItemTemplate(item: any) {
    return (
      <div className={classes.listItemsTemplate}>
        <div className={classes.left}>
          <div className={classes.itemName}>{item.item}</div>
        </div>
        <div className={classes.right}>
          <div className={classes.itemListCode}>{item.code}</div>
          <div className={classes.itemListOrder}>
            {item.listOrder === null ? "—" : `List Order ${item.listOrder}`}
          </div>
          <StatusTag
            status={
              item.enabled ? ListItemStatus.Active : ListItemStatus.Inactive
            }
          />
          <MenuButton
            items={rowActions(item)}
            icon="pi-ellipsis-h"
            buttonClass={cx("p-button-text", classes.itemListActions)}
            forceIcon
          />
        </div>
      </div>
    );
  }

  return (
    <OrderList data={items} itemTemplate={getItemTemplate} disableReorder />
  );
};

export default ListItems;
